export default __webpack_public_path__ + "static/favicon-1965c2a1fd7e1ea6b5d27f8fe2dc7b1a.ico";